export default "__VITE_ASSET__B74S3Imi__"